import { Suspense, memo, useCallback } from "react";
import { Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { configRouter } from "../config/router";
import { AppRouteProps } from "../model/types";
import { CheckAccess } from "./CheckAccess";

import { Spinner, SpinnerView } from "@/shared/ui/Spinner";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const AppRouter = memo(() => {
  const renderWithWrapper = useCallback((route: AppRouteProps) => {
    const element = <Suspense fallback={<Spinner view={SpinnerView.Centered} />}>{route.element}</Suspense>;

    return (
      <Route key={route.path} path={route.path} element={<CheckAccess roles={route.roles}>{element}</CheckAccess>} />
    );
  }, []);

  return <SentryRoutes>{configRouter.map(renderWithWrapper)}</SentryRoutes>;
});
